import {
  FormField, LoadingBubbles, SelectBox, Text,
} from '@domain-group/suit-theme'

import type { ProviderPriceListModel, ServiceProductModel } from '@models/types'
import type { UseNewOrderPayload } from '@modals/NewOrderModal'

interface ProductSelectorProps {
  callbacks: {
    selectServiceProductId: UseNewOrderPayload['callbacks']['selectServiceProductId'],
  },
  currentPriceList: ProviderPriceListModel,
  loadingPriceLists: boolean,
  selectedServiceProductId: number,
  serviceProducts: ServiceProductModel[],
}

const ProductSelector = (props: ProductSelectorProps) => {
  const {
    callbacks: {
      selectServiceProductId,
    },
    currentPriceList,
    loadingPriceLists,
    selectedServiceProductId,
    serviceProducts,
  } = props

  return (
    <FormField
      label="Select Product"
      labelProps={{ flexShrink: 0, width: 'auto' }}
      labelRight={loadingPriceLists && (
        <LoadingBubbles color="blue" style={{ marginLeft: 'auto', width: 'auto' }} />
      )}
      marginTop="large"
    >
      <SelectBox
        callbacks={{
          // @ts-expect-error TS7006
          selectItem: item => selectServiceProductId(item.key),
        }}
        items={serviceProducts.map(serviceProduct => ({ key: serviceProduct.id, title: serviceProduct.title }))}
        selectedItemKey={selectedServiceProductId}
        style={{ zIndex: 14 }}
      />

      {!!currentPriceList.id && (
        <Text color="lightGrey" fontSize="xxsmall" marginTop="small" marginLeft="auto">
          #{currentPriceList.id} - {currentPriceList.title}
        </Text>
      )}
    </FormField>
  )
}

export default ProductSelector
